<template>
    <div class="container">
        <div class="row">
            <div class="col-8">
                <div class="page-headline">
                    <h2>{{pageTitle}}</h2>
                    <h1>{{subTitle}}</h1>
                </div>
            </div>
            <div class="col-4">
                <div class="filter-menu">
                    <span data-toggle="collapse" data-target="#filter-content" v-on:click="toggleFilter()" v-bind:class="{ 'filter-active': filterMenuOpen }">&raquo; {{filterText}}</span>
                    <div id="filter-content" class="collapse">
                    <ul>
                        <li><label v-bind:class="{ 'label-active': genreActive('dok') }"><input type="checkbox" value="dok" v-model="genreFilter" /> Dokumentarfilm</label></li>
                        <li><label v-bind:class="{ 'label-active': genreActive('fiction') }"><input type="checkbox" value="fiction" v-model="genreFilter" /> Szenisch</label></li>
                        <li><label v-bind:class="{ 'label-active': genreActive('commercial') }"><input type="checkbox" value="commercial" v-model="genreFilter" /> Werbung</label></li>
                        <div v-if="this.category === 'grading'">
                            <li><label v-bind:class="{ 'label-active': genreActive('animation') }"><input type="checkbox" value="animation" v-model="genreFilter" /> Animation</label></li>
                            <li><label v-bind:class="{ 'label-active': genreActive('musikvideo') }"><input type="checkbox" value="musikvideo" v-model="genreFilter" /> Musikvideo</label></li>
                            <li><label v-bind:class="{ 'label-active': genreActive('showreel') }"><input type="checkbox" value="showreel" v-model="genreFilter" /> Showreel</label></li>
                        </div>
                    </ul>
                    <div class="filler">

                    </div>
                    </div>
                </div>
            </div>
        </div>



        <transition-group class="row position-relative" tag="div" name="list-complete">
            <div class="col-12 list-complete-item" v-bind:key="p.name" v-for="(p) in projectsFiltered">
                <project-component
                        v-bind:project="p"
                        v-bind:aspectratio="aspectratio" >
                </project-component>
            </div>
        </transition-group>

    </div>
</template>


<script>
    import ProjectComponent from "@/components/Project.vue";
    import {mapState} from 'vuex';


    export default {
        name: "portfolio-page",
        metaInfo: {
            meta: [
                { charset: 'utf-8' },
                { name: 'description', content: 'Übersicht über mein Portfolio der letzten Arbeiten im Bereich Editing und Color Grading.' },
                { name: 'robots', content: 'Index' }
            ],
            title: 'Portfolio'
        },
        data: function () {
            return {
                showSpotlight: false,
                genreFilter: [],
                filterMenuOpen: false,
                filterText: "Filter öffnen",
            };
        },

        props: {
            pageTitle: {
                default: "Portfolio"
            },
            subTitle: {
                default: "Portfolio"
            },
            category: {
                default: null
            }
        },

        components: {
            ProjectComponent
        },

        computed: mapState({
            projectsFiltered: function () {
                let filtered = [];
                filtered = this.$store.state.projects.filter(this.filterProjects);
                return filtered;
            },

            aspectratio: state => state.config.aspectratio,
        }),

        methods: {
            filterProjects: function (project) {

                let show = project.group.indexOf(this.category) > -1;
                if (this.genreFilter.length === 0){
                    return show;

                } else if(show && this.genreFilter.length > 0) {
                    show = this.genreFilter.indexOf(project.filter) > -1;
                    return show;

                }
                return show;
            },

            genreActive: function (toCheck){
                let temp = this.genreFilter.indexOf(toCheck) > -1;
                return temp;
            },

            toggleFilter: function () {
                if(!this.filterMenuOpen) {
                    this.openFilter();
                } else {
                    this.closeFilter();
                }
            },

            openFilter: function () {
                this.filterMenuOpen = true;
                this.filterText = "Filter schließen"
            },

            closeFilter: function () {
                if(this.filterMenuOpen) {
                    this.filterMenuOpen = false;
                    this.filterText = "Filter öffnen"
                }
            }
    }
    };
</script>

